module.exports = __webpack_public_path__ + "static/media/taizo-yamamoto-architecture-plans.90c1a858.jpg";